import { securedAxios } from "../lib/axios";
export default {
  namespaced: true,
  actions: {
    async carregarCEP(context, cep) {
      try {
        const response = await securedAxios.get(`cep/${cep}`);
        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
